import { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import PleaseWaitOverlay from 'components/PleaseWaitOverlay';

import useHummPending from './useHummPending';

const Pending: FunctionComponent = () => {
  const { link } = useHummPending();
  return (
    <>
      <PleaseWaitOverlay
        icon="alarm"
        title="Your application has been started with our lender, Humm."
        labelLine1="You'll be redirected back to Humm soon, or you can click the button below to return to your application"
      />
      {link && (
        <a href={link} className="mx-auto mt-8">
          <Button.Text
            id="humm-return-to-application"
            label="Continue to Humm"
            className="w-64"
          />
        </a>
      )}
    </>
  );
};

export default Pending;
